<template>
  <div>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>아이디(휴대전화번호)</v-list-item-title>
        <!-- :disabled="userData.signupPath !== 'kakao'" -->
        <v-text-field
          disabled
          solo
          ref="refLoginId"
          type="text"
          label="아이디(휴대전화번호)"
          :height="formHeight"
          :rules="[cellRules.required, cellRules.counter, cellRules.check]"
          v-model="userData.loginId"
        />
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          성함 <span class="asterisk">*</span>
        </v-list-item-title>
        <v-text-field
          solo
          required
          ref="refName"
          placeholder="성함"
          :height="formHeight"
          :rules="[nameRules.required, nameRules.counter, nameRules.check]"
          v-model="userData.name"
        />
      </v-list-item-content>
    </v-list-item>
  </div>
</template>
<script>
const rulesService = require("@/utils/rules.js");
const formatService = require("@/utils/format.js");

export default {
  props: {
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      formHeight: 52,
      nameRules: rulesService.nameRules(),
      cellRules: rulesService.cellRules(),
    };
  },
};
</script>
<style lang="">
</style>